import React from "react";
import BaseListPage from "../../base/BaseListPage";
import withRouter from "../../withRouter";
import { countObjectUseCase, findObjectUseCase } from "../../usecases/object";
import schemaDashboard from "./schemaDashboard.json";
import ReportDashPresenter from "./ReportDashPresenter";
import NavBar2 from "../../components/NavBar2";
import printComponent from "../../printComponent";
import ExportPdfDash2 from "../../components/ExportPdfDash2";
import LoadingState from "../../components/LoadingState";
import InitialPrompt from "../../components/InitialPrompt";
import DashboardFilters from "./components/DashboardFilters";
import DashboardActions from "./components/DashboardActions";
import DashboardCards from "./components/DashboardCards";
import { formatDashboardData } from "./utils/dashboardUtils";
import ProgressLoader from "../../components/ProgressLoader";

class ReportDashPage extends BaseListPage {
  constructor(props) {
    super(props);
    this.presenter = new ReportDashPresenter(
      this,
      findObjectUseCase(),
      countObjectUseCase()
    );
    this.state = {
      objects: [],
      selected: [],
      progress: true,
      count: 0,
      where: {},
      trans: null,
      startDate: "",
      endDate: "",
      range: "",
      storess: "",
      store: [],
      notFound: false,
    };
    this.certRef = React.createRef();
  }

  getCollectionName() {
    return "transactions";
  }

  onChangeStore(where) {
    this.setState({ storess: where });
    this.presenter.onChangeStore(where);
  }

  setStore(store) {
    this.setState({ store });
  }

  onChangeDate(where) {
    const startDate = where.createdAt?.$gte
      ? new Date(where.createdAt.$gte)
      : new Date();
    const endDate = where.createdAt?.$lte
      ? new Date(where.createdAt.$lte)
      : new Date();

    if (startDate.toDateString() === endDate.toDateString()) {
      endDate.setHours(23, 59, 59, 999);
    }

    const formattedStartDate = startDate.toLocaleDateString();
    const formattedEndDate = endDate.toLocaleDateString();

    this.presenter.onChangeDate(where);
    this.setState({ range: where });

    this.setState({
      startDate: formattedStartDate,
      endDate: formattedEndDate,
    });
  }

  getValueForDashboardObject(object) {
    switch (object.label) {
      case "Delivery":
        return this.presenter.calculateDeliveryInfo();
      case "Dine In":
        return this.presenter.calculateDineInfo();
      case "Take Out":
        return this.presenter.calculateTakeOutInfo();
      case "Grab Food":
        return this.presenter.calculateGrabFoodInfo();
      case "Pick Up":
        return this.presenter.calculatePickUpInfo();
      case "Del Time":
        return this.presenter.calculateDelTimeInfo();
      case "Drive Thru":
        return this.presenter.calculateDriveInfo();
      case "FoodPanda":
        return this.presenter.calculatePandaInfo();
      default:
        return { value: 0, percentage: 0 };
    }
  }

  handleCountClick(nav) {
    this.navigateTo(nav);
  }

  onClickPrint() {
    this.setStatePromise()
      .then(() => printComponent(this.certRef.current, "certificate"))
      .then((result) => {
        console.log(result);
      })
      .catch((error) => {
        alert(error);
      });
  }

  onClickExport() {
    const filteredObj = this.state.objects.filter((obj) => obj.status === "C");
    this.presenter.onClickExport(filteredObj);
  }

  getProgressPercentage() {
    const { objects, count } = this.state;
    if (!count || count === 0) return 0;
    return Math.min(Math.round((objects.length / count) * 100), 100);
  }

  setNotFound(notFound) {
    this.setState({ notFound });
  }

  render() {
    const { objects, store, storess, range, startDate, endDate } = this.state;
    const filtered = objects.filter((o) => o.status === "C");
    const data = formatDashboardData(
      schemaDashboard,
      this.presenter,
      startDate,
      endDate,
      filtered
    );
    const chartId = "chart-container30";

    return (
      <>
        <div className="d-none" ref={this.certRef}>
          <ExportPdfDash2 data={data} />
        </div>
        <NavBar2
        // action={() => (
        //   <DashboardActions
        //     // onClickExport={this.onClickExport.bind(this)}
        //     chartId={chartId}
        //   />
        // )}
        />
        <div className="overflow-auto">
          <div className="p-3 p-lg-4">
            <h1
              className="fw-bold mt-3 text-capitalize"
              style={{ color: "#83c14a" }}
            >
              Sales Dashboard
            </h1>
            <DashboardFilters
              onChangeDate={this.onChangeDate.bind(this)}
              onChangeStore={this.onChangeStore.bind(this)}
              store={store}
              range={range}
            />
            {objects.length > 0 ? (
              <>
                <ProgressLoader
                  loaded={this.state.objects.length}
                  total={this.state.count}
                  getProgressPercentage={() => this.getProgressPercentage()}
                />
                <DashboardCards
                  schemaDashboard={schemaDashboard}
                  presenter={this.presenter}
                  objects={objects}
                  onClick={(target) => this.handleCountClick(target)}
                />
              </>
            ) : !storess || !range ? (
              <InitialPrompt twoFilter />
            ) : this.state.notFound ? (
              <div className="text-center mt-5">
                <p className="text-muted fs-5">
                  📭 Data not found for selected filter.
                </p>
              </div>
            ) : (
              <div className="text-center mt-5">
                <LoadingState />
              </div>
            )}
          </div>
        </div>
      </>
    );
  }
}

export default withRouter(ReportDashPage);
